import FittersLocator from './containers/FittersLocator';

export const fittersLocatorRoutes = {
    path: '/fitters-locator',
    component: FittersLocator
}


// WEBPACK FOOTER //
// ./src/fitters-locator/routes.js